import { makeStyles } from "@material-ui/styles";

const gameSummaryStyles = makeStyles((theme) => ({
	teamSummary: {
		flex: 1,
		[theme.breakpoints.down("xs")]: {
			paddingTop: "0px !important"
		}
	}
}));

export default gameSummaryStyles;
